import { useEffect, useMemo, useState } from 'react'

import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { useAuthMember } from '@tribeplatform/react-sdk/hooks'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { Form } from '../../../Form/index.js'
import { useI18n } from '../../../i18n/index.js'
import { NewChatFormFields } from '../../types.js'

export const NewGroupNameField = () => {
  const { control, setValue } = useFormContext()
  const { data: authMember } = useAuthMember()
  const { $t } = useI18n()
  const [isNameEdited, setIsNameEdited] = useState(false)
  const members: NewChatFormFields['members'] = useWatch({
    control,
    name: 'members',
  })
  const selectedMembers = useMemo(() => {
    if (!members) {
      return []
    }

    const selected = Array.isArray(members) ? members : [members]
    const filtered = selected.filter(item => item.id !== authMember?.id)

    return [authMember, ...filtered]
  }, [members, authMember])

  useEffect(() => {
    if (!isNameEdited && selectedMembers.length > 0) {
      if (selectedMembers.length <= 2) {
        setValue('name', selectedMembers.map(member => member.name).join(', '))
      } else {
        const firstTwoMembersNames = selectedMembers
          .slice(0, 3)
          .map(member => member.name)
          .join(', ')
        setValue('name', `${firstTwoMembersNames} ...`)
      }
    }
  }, [selectedMembers, isNameEdited, setValue, $t, authMember])

  return (
    <Controller
      name="name"
      control={control}
      render={({ field }) => (
        <Form.Input
          {...field}
          required
          label={
            <Text className="text-content-muted text-sm">
              {$t({
                defaultMessage: 'Group name',
                id: 'Messaging.NewGroupChatModal.NameField.Label',
              })}
            </Text>
          }
          placeholder={$t({
            defaultMessage: 'Name of the group',
            id: 'Messaging.NewGroupChatModal.NameField.Placeholder',
          })}
          onChange={e => {
            setIsNameEdited(true)
            field.onChange(e)
          }}
        />
      )}
    />
  )
}
